export default {"src":"/_next/static/media/cn.531c670a.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};